<template>
  <div>
    <v-container>
      <div class="breadcrumbs-wrap">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <h1 class="title-pg">{{ $t('Сводные отчеты') }}</h1>
      <div class="search-pg workroom-pg">
        <v-form
          ref="form"
          lazy-validation
          v-model="valid"
          @submit.prevent="generateReport"
        >
          <div class="search-head bgw-pdg-20">
            <v-row>
              <v-col
                cols="12"
                sm="5"
                :class="{ invalid: $v.search.report.$error }"
              >
                <v-label>{{ $t('Тип отчета') }}</v-label>
                <div class="select-def">
                  <v-select
                    :items="reports"
                    item-value="id"
                    item-text="transName"
                    v-model="search.report"
                    :placeholder="$t('Все')"
                    outlined
                    dense
                    clearable
                    @change="setStatuses"
                  />
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="2"
                :class="{ invalid: $v.search.year.$error }"
              >
                <v-label>{{ $t('Год учета') }}</v-label>
                <div class="select-def">
                  <v-select
                    :items="years"
                    item-value="id"
                    item-text="transName"
                    v-model="search.year"
                    :placeholder="$t('Все')"
                    outlined
                    dense
                    clearable
                    @change="observePlotListData"
                  />
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="3"
                v-if="!(soates.length === 1 && ooptTypes.length === 1 && oopts.length === 1)"
              >
                <v-label>{{ $t('Область') }}</v-label>
                <div class="select-def">
                  <v-select
                    :items="soates"
                    item-value="id"
                    item-text="fullTransName"
                    v-model="filters.soate"
                    :placeholder="$t('Все')"
                    outlined
                    dense
                    clearable
                    @change="ooptListData"
                  />
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="3"
                v-if="!(soates.length === 1 && ooptTypes.length === 1 && oopts.length === 1)"
              >
                <v-label>{{ $t('Тип организации') }}</v-label>
                <div class="select-def">
                  <v-select
                    :items="ooptTypes"
                    item-value="id"
                    item-text="transName"
                    v-model="search.ooptType"
                    :placeholder="$t('Все')"
                    outlined
                    dense
                    clearable
                    @change="ooptListData"
                  />
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="3"
                v-if="!(soates.length === 1 && ooptTypes.length === 1 && oopts.length === 1)"
              >
                <v-label>{{ $t('Организация') }}</v-label>
                <div class="select-def">
                  <v-autocomplete
                    :items="oopts"
                    item-value="id"
                    item-text="transName"
                    v-model="filters.oopt"
                    :placeholder="$t('Все')"
                    outlined
                    dense
                    clearable
                    @change="observePlotListData"
                  />
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="3"
                v-if="search.report !== form_event"
              >
                <v-label>{{ $t('Участок') }}</v-label>
                <div class="select-def">
                  <v-select
                    :items="observePlots"
                    item-value="id"
                    item-text="transName"
                    v-model="filters.observePlot"
                    :placeholder="$t('Все')"
                    outlined
                    dense
                    clearable
                  />
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="3"
                v-if="search.report !== form_observe_plot_explication"
              >
                <v-label>{{ $t('Статус') }}</v-label>
                <div class="select-def">
                  <v-select
                    :items="statuses"
                    item-value="id"
                    item-text="transName"
                    v-model="filters.status"
                    :placeholder="$t('Все')"
                    outlined
                    dense
                    clearable
                  />
                </div>
              </v-col>
            </v-row>
            <div class="search-action">
              <button
                class="btn btn-default green-grassy"
                type="submit"
                @click="filters.word = false"
              >
                {{ $t('Генерировать отчет') }}
              </button>
              <button
                class="btn btn-default green-grassy"
                type="submit"
                @click="filters.word = true"
              >
                {{ $t('Печать в Word') }}
              </button>
              <button
                class="btn btn-default gray"
                type="button"
                @click="resetForm"
              >
                {{ $t('Очистить') }}
              </button>
            </div>
            <div class="hint">
              <p><span v-if="labelSoateName">{{ $t('Область') }}: {{ labelSoateName }}</span> <span v-if="labelOoptName">{{ $t('Организация') }}: {{ labelOoptName }}</span></p>
            </div>
          </div>
        </v-form>
        <div class="bgw-pdg-20 my-organization" v-if="reportId">
          <div class="table-overflow">
            <SummaryInformation
              v-if="form_accounting_6 === reportId"
              :reportData="reportData.data"
              :year="year"
              :oopt="oopt"
              ref="SummaryInformation"
            />
            <AgeComposition
              v-if="form_accounting_6a === reportId"
              :reportData="reportData"
              :year="year"
              :oopt="oopt"
              ref="AgeComposition"
            />
            <SummaryInformationOndatra
              v-if="form_accounting_ondatra === reportId"
              :reportData="reportData.data"
              :year="year"
              :oopt="oopt"
              ref="SummaryInformationOndatra"
            />
            <SummaryInformationMarmot
              v-if="form_accounting_marmot === reportId"
              :reportData="reportData.data"
              :year="year"
              :oopt="oopt"
              :soate="soateName"
              :mainSoate="mainSoateName"
              ref="SummaryInformationMarmot"
            />
            <SummaryEvent
              v-if="form_event === reportId"
              :reportData="reportData.eventData"
              :header="reportData.header"
              :total="reportData.total"
              :year="year"
              :oopt="oopt"
              ref="SummaryEvent"
            />
            <SummaryExplication
              v-if="form_observe_plot_explication === reportId"
              :reportData="reportData.data"
              :header="reportData.header"
              :year="year"
              :oopt="oopt"
              ref="SummaryExplication"
            />
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import Report from '@/model/report'
import SummaryInformation from '@/components/report/SummaryInformation'
import SummaryInformationOndatra from '@/components/report/SummaryInformationOndatra'
import SummaryInformationMarmot from '@/components/report/SummaryInformationMarmot'
import AgeComposition from '@/components/report/AgeComposition'
import SummaryEvent from '@/components/report/SummaryEvent'
import SummaryExplication from '@/components/report/SummaryExplication'
import { required } from 'vuelidate/lib/validators'

export default {
  components: {
    SummaryExplication,
    SummaryInformation,
    SummaryInformationOndatra,
    SummaryInformationMarmot,
    AgeComposition,
    SummaryEvent
  },
  mounted () {
    this.fetchData()
    this.scrollToTop()
  },
  data: () => ({
    search: {},
    filters: {},
    oopts: [],
    reports: [],
    ooptTypes: [],
    soates: [],
    observePlots: [],
    years: [],
    statuses: [],
    animalAccountingStatuses: [],
    eventReportStatuses: [],
    breadcrumbs: [],
    reportData: [],
    form_accounting_6: null,
    form_accounting_6a: null,
    form_accounting_marmot: null,
    form_accounting_ondatra: null,
    form_event: null,
    form_observe_plot_explication: null,
    reportId: null,
    valid: true,
    rules: {
      search: {
        year: { required },
        report: { required }
      }
    },
    year: null,
    oopt: null,
    statisticContent: null,
    soateName: null,
    mainSoateName: null,
    labelSoateName: null,
    labelOoptName: null
  }),
  validations () {
    return this.rules
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      Report.getGenerateFormData()
        .then((res) => {
          this.reports = res.data.reports
          this.years = res.data.years
          this.animalAccountingStatuses = res.data.animalAccountingStatuses
          this.eventReportStatuses = res.data.eventReportStatuses
          this.ooptTypes = res.data.ooptTypes
          this.soates = res.data.soates
          this.form_accounting_6 = res.data.form_accounting_6
          this.form_accounting_6a = res.data.form_accounting_6a
          this.form_accounting_marmot = res.data.form_accounting_marmot
          this.form_accounting_ondatra = res.data.form_accounting_ondatra
          this.form_event = res.data.form_event
          this.form_observe_plot_explication = res.data.form_observe_plot_explication
          if (this.ooptTypes.length === 1 && this.soates.length === 1) {
            const ooptType = this.ooptTypes[0]
            const soate = this.soates[0]
            this.filters.soate = soate.id
            this.search.ooptType = ooptType.id
          }
          this.breadcrumbs = [
            {
              text: this.$i18n.t('Главная'),
              disabled: false,
              href: '/'
            },
            {
              text: this.$i18n.t('Рабочий кабинет'),
              disabled: false,
              href: '/my-organization'
            },
            {
              text: this.$i18n.t('Сводные отчеты'),
              disabled: true
            }
          ]
          this.ooptListData()

          this.setLoading(false)
        })
        .catch((error) => {
          this.$router.push({
            name: 'error',
            params: {
              status: error.response.status
            }
          })
          this.setLoading(false)
        })
    },
    ooptListData () {
      const soate = this.soates.find(x => x.id === this.filters.soate)
      this.labelSoateName = soate ? soate.fullTransName : null
      if (!this.filters.soate) {
        this.oopts = []
        this.labelOoptName = null
        delete this.filters.oopt
        delete this.filters.observePlot
        return
      }
      Report.getOoptDataBySoateAndType(this.filters.soate, this.search.ooptType)
        .then((res) => {
          this.oopts = res.data.oopts
          if (this.oopts.length === 1) {
            const oopt = this.oopts[0]
            this.filters.oopt = oopt.id
          }
          if (this.filters.oopt) {
            if (this.oopts.findIndex(x => x.id === this.filters.oopt) === -1) {
              this.filters.oopt = null
            }
          }
          this.observePlotListData()
        })
        .catch((error) => {
          console.log(error)
        })
    },
    setStatuses () {
      if (this.search.report === undefined || this.search.report === this.form_observe_plot_explication) {
        this.statuses = []
        return
      }
      this.statuses = this.form_event === this.search.report ? this.eventReportStatuses : this.animalAccountingStatuses
    },
    observePlotListData () {
      const oopt = this.oopts.find(x => x.id === this.filters.oopt)
      this.labelOoptName = oopt ? oopt.transName : null
      if (!this.filters.oopt) {
        this.observePlots = []
        delete this.filters.observePlot
        return
      }
      Report.getObservePlotByOoptAndYear(this.filters.oopt, this.search.year)
        .then((res) => {
          this.observePlots = res.data.observePlots
          if (this.filters.observePlot) {
            if (this.observePlots.findIndex(x => x.id === this.filters.observePlot) === -1) {
              this.filters.observePlot = null
            }
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    generateReport () {
      if (!this.validateForm()) return
      this.setLoading(true)
      Report.getGeneratedReportData(this.search.report, this.search.year, this.filters)
        .then((res) => {
          if (this.filters.word === true) {
            this.forceFileDownload(res)
          } else {
            this.reportData = res.data.reportData
            this.reportId = res.data.reportId
            this.year = res.data.year
            this.oopt = res.data.ooptTransName
            this.soateName = res.data.soateName
            this.mainSoateName = res.data.mainSoateName
          }
        })
        .catch((err) => {
          console.log(err)
        })
      this.setLoading(false)
    },
    // генерация ссылки для скачивания ворд файла
    forceFileDownload (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', this.search.report === this.form_event ? 'форма.xlsx' : 'форма.docx')
      document.body.appendChild(link)
      link.click()
    },
    // Валидация формы
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    // Сброс формы
    resetForm () {
      this.search = {}
      this.filters = {}
      this.reportId = null
      this.reportData = []
      this.statuses = []
      this.labelOoptName = null
      this.labelSoateName = null
      this.$v.$reset()
      this.fetchData()
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    }
  }
}
</script>
<style scoped>
.search-pg .search-head .hint {
  margin: 20px 0 0;
}
</style>
